import { Navigate } from 'react-router-dom'
import { useSession } from 'gunsi-auth'
import { useTallyI18n } from '../i18n/tally.js'

const GP_LOGO_URL = `${import.meta.env.VITE_AUTH_PORTAL_URL ?? `${location.protocol}//${location.hostname}:5174`}/gp_logo_2d.png`

export function Home() {
  const { session, loading } = useSession()
  const t = useTallyI18n()

  if (!loading && session) return <Navigate to="/dashboard" replace />

  const authPortal = import.meta.env.VITE_AUTH_PORTAL_URL ?? `${location.protocol}//${location.hostname}:5174`
  const heYear = new Date().getFullYear() + 10000

  return (
    <main className="home">
      <div className="home-inner">
        <h1 className="home-big-title">
          <span className="home-big-line">
            <span className="home-big-mark" aria-hidden="true" />
            <span className="home-big-text">ally</span>
          </span>
        </h1>
        <p className="home-sub">{t.home.sub}</p>
        {!loading && (
          <a
            href={`${authPortal}/login?next=${encodeURIComponent(window.location.href)}`}
            className="home-cta"
          >
            {t.home.cta}
          </a>
        )}
      </div>
      <footer className="home-footer">
        <span>©{heYear} Gunsi Productions</span>
        <img src={GP_LOGO_URL} alt="Gunsi Productions" />
      </footer>
    </main>
  )
}
